import * as Sentry from '@sentry/nextjs';

export const missingKeyLoggingConfig = {
    saveMissing: true,
    saveMissingTo: 'current',
    missingKeyHandler: (language, namespace, key) => {
        Sentry.captureException(
            new Error(
                `TranslationMissing (javascript) - Unable to find key ${key} (namespace ${namespace}) in language ${language}!`
            )
        );
    },
    missingInterpolationHandler: (text, value) => {
        Sentry.captureException(
            new Error(
                `InterpolationFailure (javascript) - Unable to interpolate the text "${text}" fully. The following placeholder values were missing: ${JSON.stringify(
                    value
                )}`
            )
        );
        return undefined;
    }
};
